module.exports = __webpack_public_path__ + "img/b004ecf.png";